import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Upload} from 'kpc';
import {Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$refs = this.refs;
    var _$ref_instance = function(i) {_$refs['instance'] = i};
    
    return _$cc(Upload, {
        'ref': _$ref_instance,
        'multiple': true,
        'action': '//fakestoreapi.com/products',
        'autoUpload': false,
        'children': (
            _$cc(Button, {
                'type': 'primary',
                'children': '选择文件'
            })
        ),
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['tip'] = function($super) {
                        return (
                            _$cc(Button, {
                                'ev-click': this.upload,
                                'children': '开始上传'
                            })
                        );
                    }),
                    (__$blocks['tip'] = function($super, data) {
                        var block = $blocks['tip'];
                        var callBlock = function() {
                            return _$blocks['tip'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em)
    }, null, _$ref_instance);
};